import { SoftwareWCActionType } from '../../actions/ActionType'

const initialState = {
    loading: false,
    objeckt:[]
}

type action = {
    type: string
    objeckt?: any
}

const SoftwareWCReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case SoftwareWCActionType.SoftwareWC_INIT:
            return {
                ...state,
                objeckt:action.objeckt,
                loading: true
            }
        default:
            return state
    }
}

export default SoftwareWCReducer
